// Content for the multi-page GME ecosystem site.
import { IMG } from "./homeContent";

const WK = "/assets/wisdomkeepers";

export const WISDOM_KEEPERS_GALLERY = [
  { img: `${WK}/dalailama.webp`, name: "His Holiness the Dalai Lama" },
  { img: `${WK}/desmond.webp`, name: "Archbishop Desmond Tutu" },
  { img: `${WK}/beckwith.webp`, name: "Michael Bernard Beckwith" },
  { img: `${WK}/byronkatie.webp`, name: "Byron Katie" },
  { img: `${WK}/dispenza.webp`, name: "Dr. Joe Dispenza" },
  { img: `${WK}/huerta.webp`, name: "Dolores Huerta" },
  { img: `${WK}/harvey.webp`, name: "Andrew Harvey" },
  { img: `${WK}/anodea.webp`, name: "Anodea Judith" },
  { img: `${WK}/sarahmccrum.webp`, name: "Deva Premal, Miten & Sarah McCrum" },
  { img: `${WK}/cryer.webp`, name: "Bruce Cryer" },
  { img: `${WK}/naram.webp`, name: "Dr. Pankaj Naram" },
];

export const STORY = {
  hero: {
    eyebrow: "The Origin",
    h: "A Life that answers to something higher.",
    sub: "An extraordinary life is one lived in service of something bigger than the man. Driven by music, guided by grief, Gary Malkin spent five decades helping people find words for what they feel.",
    img: "/assets/team/gary-malkin-suit.jpg",
  },
  // Evolutionary Journey — final approved copy from the 2608 brief. Note chapter 02
  // deliberately says "industry recognition" rather than counting awards, per §6.
  chapters: [
    { n: "01", title: "A Boy at the Piano", body: "It began at five, at the piano — when this little boy began discovering that music could express what words could not, awaken something deeply alive within us, and bring people together in ways almost nothing else could.", img: IMG.pianoWarm },
    { n: "02", title: "Cultivating the Craft", body: "Decades scoring for film and television — earning industry recognition while building one of the Bay Area's busiest music production houses and mastering the craft of using music to move emotion, tell stories, and reach millions.", img: IMG.studio },
    { n: "03", title: "The Turning", body: "A life-altering injury interrupted everything. Through the long healing process came a deeper question: What was this lifelong gift really for? The answer opened a new chapter—using music not only to move people, but to awaken us more fully to the precious gift of being human.", img: IMG.contemplation },
    { n: "04", title: "Music as Medicine", body: "From that turning came a pioneering new way of sharing wisdom—weaving intimate spoken messages with evocative music so wisdom could be felt in the heart before it was understood by the mind. Graceful Passages became its landmark expression, reaching more than a million people and inspiring a body of work accompanying the entire human journey—from birth and belonging to leadership, loss, and legacy.", img: IMG.candle },
    { n: "05", title: "The Art of Human Being", body: "Today, a lifetime of inquiry is converging into Resonance Intelligence—awakening the deeply human capacities we need most in an AI-accelerated world, and bringing greater presence, connection, creativity, compassion, meaning, and wisdom into how we live, lead, and create.", img: IMG.mistyGold },
  ],
  quote: "Artificial intelligence may be humanity’s greatest invitation to become fully human.",
};

export const WORK_HUB = {
  eyebrow: "The Work",
  h: "Where the work meets you.",
  sub: "Begin with yourself, extend to the rooms you lead, or honor what you leave behind.",
  // Doorway names locked by the 2608 directive §2 — these must match the homepage exactly.
  pathways: [
    { key: "yourself", to: "/work/yourself", kicker: "Human Capacities", title: "Resonance Leadership Immersion", who: "For leaders & practitioners", body: "Reconnect heart and mind, release the pressure you carry, and lead from a deeper coherence.", img: IMG.contemplation },
    { key: "event", to: "/work/event", kicker: "Resonance Catalyst", title: "Resonance Performance Experience", who: "For organizations & events", body: "Turn any gathering into a moment people never forget — keynote, live underscoring, and immersive experience.", img: IMG.keynote2 },
    { key: "legacy", to: "/work/legacy", kicker: "Living Legacies", title: "The Living Legacy Project", who: "For individuals & families", body: "Preserve the essence of a remarkable life in a cinematic, music-infused heirloom of meaning.", img: IMG.candle },
    { key: "healthcare", to: "/work/healthcare", kicker: "Human-Centered Healthcare", title: "Care for the Journey", who: "For health systems & care teams", body: "Renewal for the people who carry others through the hardest hours — presence, grief literacy, and a way back to why they chose this work.", img: IMG.handsSun },
    { key: "presentations", to: "/work/presentations", kicker: "Presentations and Performances", title: "Keynotes, Conversations & Performances", who: "For conferences, festivals & communities", body: "Ideas, story, music and lived experience brought to the questions your audience is already carrying.", img: IMG.auditorium },
  ],
};

// WORK_DETAIL removed 2026-08-25 — superseded by DOORWAY_PAGES in doorwayContent.js,
// which implements the §45 conversion structure across all five doorway pages.

export const WORLD = {
  eyebrow: "Gary's World",
  h: "One ecosystem. Many worlds.",
  sub: "The work lives across a constellation of ventures, foundations, and bodies of work — each a different way into the art of human being.",
  properties: [
    { title: "Portals of Awe", note: "Music-as-medicine paired with neuro-technology for daily coherence.", img: IMG.meditation, to: "/#portals" },
    { title: "Graceful Passages", note: "Music for life's most important moments — over a million accompanied.", img: IMG.candle, to: "/graceful-passages" },
    { title: "Wisdom of the World", note: "Gary's library of compositions, films, and contemplative works.", img: IMG.orchestra, to: "/listen" },
    { title: "Global Wisdom Foundation", note: "We Rise As One — advancing a more humane and compassionate world.", img: IMG.gathering, to: "/connect" },
    { title: "Transformance", note: "Resonance and presence for leaders and organizations.", img: IMG.leadership, to: "/work/event" },
    { title: "You Awake", note: "Contemplative experiences for waking up to being alive.", img: IMG.mistyGold, to: "/listen" },
  ],
};

// Free gift — three curated tracks from the library (swap for dedicated gift tracks later).
export const GIFT = {
  eyebrow: "The Most Incredible Free Gift",
  h: "Three pieces of music, for the moments that matter.",
  sub: "No cost. No catch. Just enter where to send them, and let the music meet you where you are.",
  trackIds: [8, 11, 14],
  source: "free-gift",
};

export const LOVE_YOUR_LIFE = {
  title: "Love Your Life! Awakening to the Beauty of Being Alive",
  deck: "A groundbreaking workshop for transforming grief into gratitude—and embracing your one wild and precious life.",
  introduction: [
    "To live is to walk hand in hand with change.",
    "Yet the pace of change in recent years has been unlike anything we have ever known. Personal losses, global uncertainty, and constant adaptation have left many of us moving from one challenge to the next with little opportunity to pause, breathe, or grieve what has been left behind.",
    "We've carried responsibilities, losses, disappointments, uncertainty, and change for so long that somewhere along the way, life became something to manage instead of something to savor.",
    "We don't realize we've slowly gone offline.",
    "When grief goes unacknowledged, it doesn't simply disappear. It quietly settles beneath the surface, often revealing itself in subtle ways: less joy in everyday life, diminished energy, disconnection from others, abandoned healthy habits, or a lingering sense that something essential has been lost. We’ve forgotten who we are.",
    "The good news is that grief is not the end of the story.",
    "When we meet it with compassion, presence, and the right support, it can become a doorway to greater resilience, deeper purpose, renewed vitality, and profound gratitude for the miracle of being alive.",
    "How do we come back to ourselves?",
  ],
  workshop: [
    "Love Your Life! is an immersive workshop inspired by the internationally acclaimed resource on grief literacy, Graceful Passages, created by Emmy Award-winning composer Gary Malkin and the pioneering team of Michael and Doris Stillwater.",
    "Through healing music, contemplative practices, channeled transmissions, joyful play, heart-centered dialogue and the support of a loving community, this unique process gently restores vitality while helping to navigate life's inevitable changes with greater wisdom and grace.",
  ],
  processHeading: "Our Four-Step Chrysalis Process explores how to:",
  process: [
    "Address and gently metabolize unresolved grief from the past",
    "Cultivate greater self-love through acceptance, compassion, and forgiveness",
    "Face uncertainty - including our own mortality - with courage and openness",
    "Awaken gratitude, joy, and a renewed appreciation for the preciousness of life",
  ],
  practicesIntro: "Along the way, the transformative medicine of Gary Malkin's immersive music and Hope Fitzgerald’s mastery as a transmissive spiritual intuitive and guide offer powerful practices designed to:",
  practices: [
    "expand the emotional landscape,",
    "accelerate healing and integration,",
    "engage the body, mind, and soul’s innate intelligence,",
    "and transform loss into liberation, resistance into acceptance, fear into peace, and uncertainty into possibility.",
  ],
  quote: "Mary Oliver asked: \"Tell me, what is it you plan to do with your one wild and precious life?\"",
  closing: [
    "We believe that question becomes most meaningful when we allow ourselves to fully embrace both life's sorrows and its extraordinary beauty.",
    "Like the caterpillar that can never imagine becoming a butterfly, life's greatest transitions often invite us to emerge as a more authentic, compassionate, and awakened version of ourselves.",
    "We invite you to join Gary and Hope for an intimate weekend of healing, discovery, music, laughter, reflection, and transformation.",
    "Come remember who you are and reconnect with the wonder of being alive…",
    "Because your one precious life is unfolding right now.",
  ],
  source: "love-your-life",
  avatar: "families",
  pathway: "legacy",
  interest: "love-your-life-workshop",
};

export const RESONANCE_TOUCHSTONES = {
  title: "Resonance Touchstones",
  subtitle: "Words to Remember. Principles to Live By.",
  statements: [
    "Bring along your whole human, wherever you go.",
    "Your mind is brilliant. It was never meant to conduct or perform the whole orchestra.",
    "Let music call you home to your wholeness—and your wholeheartedness.",
    "Beauty can slow you down enough to feel what you already know, and remember what you have forgotten.",
    "Presence before performance.",
    "Make room for the eloquence of silence.",
    "Listen beneath the words, between the melodies, and within the silence.",
    "Embrace collective listening as a form of prayer—deepening connection, strengthening compassion, and affirming your interconnectedness.",
    "When you receive beautiful music together, the felt boundaries of separateness can begin to soften.",
    "Wisdom understood is valuable. Wisdom felt is revelatory. Wisdom embodied changes lives.",
    "Stay astonished. Beginner’s mind is a gateway to lifelong, whole-being intelligence.",
    "Remember who you are. Remember that you will disappear one day. Love life. And while you are here, learn to love yourself.",
    "When you learn to grieve, you enlarge your capacity to love.",
    "Gratitude can hold your sorrow. Open to it with all you’ve got.",
    "Tell the truth with tenderness. Live your truth with vulnerability.",
    "Authenticity opens doors that performance keeps closed.",
    "The Journey to We begins when your knowing makes room for mine.",
    "Collaboration does not require agreement. It allows your collective intelligence to become larger than any one of us.",
    "When you sing together long enough, strangers will begin remembering that they belong.",
    "Unity does not require sameness. We are unique. We are human. We are one.",
    "Reverence changes behavior. Reverence awakens trust.",
    "Purpose deserves prosperity. Prosperity requires purpose.",
    "Legacy is what you cultivate in life that remains alive in those you’ve touched.",
    "Honor evidence. Leave room for mystery.",
    "In the age of AI, becoming a whole human being may be your greatest asset.",
    "Your humanity is not your fallback. It is your responsibility.",
    "Slow down enough to hear the other intelligences within you.",
    "Awe begins where certainty loosens its grip.",
    "You must not use music merely to change the mood. Use music to change the conditions in which you experience life—and therefore what becomes available to all of us.",
    "Your deepest technology may still consist of you being fully present with another human being, open to the mystery and grandeur of being alive.",
    "Let what you create serve life.",
  ],
  previewIndexes: [4, 27, 30],
  source: "resonance-touchstones",
  avatar: "community",
  interest: "resonance-touchstones-pdf",
};

// Graceful Passages conversion page + designed order bumps (no live charge yet).
export const GRACEFUL = {
  eyebrow: "Graceful Passages",
  h: "For life's most important moments.",
  sub: "A companion in sound for transition, remembrance, and the beauty of being alive — accompanying over a million people through the thresholds that matter most.",
  previewIds: [11, 8, 12],
  bumps: [
    { id: "companion-guide", title: "Graceful Passages Companion Guide", note: "A printable reflection guide to move through each piece with intention.", price: 17 },
    { id: "extended-album", title: "Extended Album + Spoken Reflections", note: "The full-length album with additional passages and guided spoken word.", price: 33 },
  ],
  source: "graceful-passages",
};

export const CONNECT = {
  eyebrow: "Connect",
  h: "Begin a conversation.",
  sub: "Whether you're planning an event or simply want to stay close to the work, there's a doorway here for you.",
  form: {
    title: "Get in Touch",
    note: "Tell us what's on your mind, and we'll route it to the right place.",
    withMessage: true,
    topics: [
      { key: "speaking", label: "Speaking & Events", source: "connect-speaking", avatar: "organizations", cta: "Send Event Inquiry" },
      { key: "general", label: "General Connect", source: "connect-general", avatar: "community", cta: "Send Message" },
    ],
  },
};

export const PRICING = {
  eyebrow: "Investment",
  h: "Ways to begin.",
  sub: "Some experiences have a set price. Others are shaped around what you are actually trying to create, and begin with a conversation.",
  // 2608 directive §7/§53. Removed from public view: every Resonance Leadership Immersion
  // figure (both the superseded May number and the newer per-person range) and every Living
  // Legacy commission range (both documented ladders). Retained: confirmed product pricing
  // (Portals of Awe, Graceful Passages) and the documented event tiers.
  // Figures themselves are kept out of this file so the §58 QA sweep stays clean — they live
  // in the project brain instead (concepts/five-doorways.md).
  rows: [
    { offering: "Portals of Awe — Tier 1", price: "$14/month" },
    { offering: "Portals of Awe — Tier 2", price: "$47" },
    { offering: "Portals of Awe — Founding Circle", price: "$1,497/year" },
    { offering: "Graceful Passages — Full Collection", price: "$27" },
    // Named to match the offer page exactly (it calls this the Companion Guide), and the
    // second add-on was missing here entirely. §53: /pricing must not contradict the offer pages.
    { offering: "Graceful Passages — Companion Guide (add-on)", price: "+$17" },
    { offering: "Graceful Passages — Extended Album + Spoken Reflections (add-on)", price: "+$33" },
    { offering: "Graceful Passages Kit", price: "$997" },
    { offering: "Resonance Keynote", price: "$10,000–$15,000" },
    { offering: "Resonance Experience", price: "$15,000–$25,000" },
    { offering: "Event Add-ons", price: "$3,000–$25,000" },
    { offering: "Resonance Leadership Immersion", price: "By application" },
    { offering: "Living Legacies — all commissions", price: "By conversation" },
  ],
  note: "Living Legacies and the Resonance Leadership Immersion are shaped individually. Tell us what you have in mind and we will scope it with you.",
  cta: "Start a Conversation",
};
